<template>
	<form
		v-if="!isSend"
		action="/api/public/form/result/add/"
		ref="form"
		class="gos-faq-official"
		@click="errorResponse.error = false"
	>
		<input type="hidden" name="code" value="gos_faq_official_form" />
		<input
			type="hidden"
			name="form[QUESTION]"
			:value="title ? title : questionTitle"
		/>
		<input
			type="hidden"
			name="form[QUESTION_ID]"
			:value="id ? id : questionId"
		/>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('NAME') }" class="input">
				<input
					v-model="form.NAME"
					class="input__field"
					name="form[NAME]"
					type="text"
					placeholder="ФИО"
					autocomplete="off"
				/>
				<span class="input__error">Это поле обязательно к заполнению</span>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('COMPANY') }" class="input">
				<input
					v-model="form.COMPANY"
					class="input__field"
					name="form[COMPANY]"
					type="text"
					placeholder="Наименование организации"
					autocomplete="off"
				/>
				<span class="input__error">Это поле обязательно к заполнению</span>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('TELEPHONE') }" class="input">
				<input
					v-model.trim="form.TELEPHONE"
					class="input__field js--phone-mask"
					name="form[TELEPHONE]"
					type="tel"
					placeholder="Номер телефона"
					autocomplete="off"
					maxlength="17"
				/>
				<span class="input__error">{{ phoneErrorTxt }}</span>
			</label>
		</div>
		<div class="form__row form__row_mrg-bot_xl">
			<label :class="{ 'show-error': showInpError('EMAIL') }" class="input">
				<input
					v-model.trim="form.EMAIL"
					class="input__field"
					name="form[EMAIL]"
					type="email"
					placeholder="Email"
					autocomplete="off"
				/>
				<span class="input__error">{{ emailErrorTxt }}</span>
			</label>
		</div>
		<div class="smartcaptcha" ref="smartcaptcha"></div>
		<div class="gos-faq-modal__bottom">
			<label for="gos-faq-official-form-agree" class="checkbox">
				<input
					id="gos-faq-official-form-agree"
					v-model="form.isCheck"
					type="checkbox"
					name="form[agreement_id]"
					:value="idPersPr"
				/>
				<span class="checkbox__field"></span>
				<p class="checkbox__text">
					<span>Согласен на обработку</span>
					<span
						:data-href="idPersPr"
						class="link-colored"
						@click.prevent="openConditions"
					>
						персональных данных</span
					>
					<span> в соответствии с </span>
					<a
						class="link-colored"
						href="/upload/documents/personal_data_process.pdf"
						target="_blank"
						>политикой</a
					>
				</p>
			</label>
			<div class="g_right">
				<button
					@click.prevent="handlerSendForm()"
					:disabled="submitBtnActive"
					class="button button_type_primary button_full"
					type="submit"
				>
					<my-preloader
						v-if="isSubmitting"
						:add-class="'n-py-0 n-pr-1'"
						:add-class-preloader="'w-20px'"
					></my-preloader>
					<template v-if="isSubmitting">Скачивание PDF</template>
					<template v-else>Скачать PDF</template>
				</button>
			</div>
		</div>
		<div
			v-if="errorResponse.error"
			class="form-error"
			v-html="errorResponse.text"
		></div>
	</form>
	<div v-else class="form__success-block">
		<div class="form__success-icon">
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.1655 7.37377C13.556 6.98325 14.1892 6.98325 14.5797 7.37377L14.7369 7.53091C15.1274 7.92143 15.1274 8.5546 14.7369 8.94512L10.7299 12.9521L9.15857 11.3807L13.1655 7.37377ZM10.7299 12.9521L9.15849 14.5234L5.15155 10.5165C4.76103 10.1259 4.76103 9.49278 5.15155 9.10226L5.30869 8.94512C5.69921 8.5546 6.33237 8.55459 6.7229 8.94511L10.7299 12.9521Z"
					fill="#8BC540"
				></path>
			</svg>
		</div>
		<p class="form__title">Ваш запрос отправлен!</p>
		<p class="form__text">PDF-файл откроется в новом окне.</p>
		<p class="form__text">&nbsp;</p>
		<a @click.prevent="isSend = false" href="#!" class="u-link"
			>Попробовать снова</a
		>
	</div>
	<ui-modal
		v-show="isShowConditions"
		@modal-close="isShowConditions = false"
		ref="uiModal"
		:target="idPersPr"
		:need-close-button="true"
		class="modal_conditions"
	>
		<template v-if="contentPersPr">
			<div
				class="ui-modal-container__header ui-modal-container__header-conditions"
				v-html="headerTitle"
			/>
			<div
				class="ui-modal-container__body ui-modal-container__body-conditions"
				v-html="contentPersPr"
			/>
		</template>
		<template v-else>
			<div class="conditions s3">
				<div class="conditions-inner" style="overflow: hidden">
					загрузка согласия...
				</div>
			</div>
			<my-preloader :add-class="'n-py-8 n-px-8'" />
		</template>
	</ui-modal>
</template>

<script>
import getConditions from '../../mixins/getCondition'
import phoneMask from '../../../modules/phone-mask'
import FormHelper from '../../mixins/form-heper'
import captchaMixin from '@/js/vue-components/mixins/captcha'

export default {
	name: 'GosFaqOfficialForm',
	mixins: [FormHelper, getConditions, captchaMixin],
	props: {
		title: {
			type: String,
			default: '',
		},
		id: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			form: {
				COMPANY: '',
				NAME: '',
				TELEPHONE: '',
				EMAIL: '',
				isCheck: false,
			},
			validErrorTxt: 'Заполните поле',
			categories: ['Категория 1', 'Категория 2', 'Категория 3', 'Категория 4'],
			idPersPr: 's3',
			isShowConditions: false,
			questionId: null,
			questionTitle: null,
			errorResponse: {
				error: false,
				text: 'Пожалуйста повторите отправку формы',
			},
		}
	},
	mounted() {
		phoneMask(document.querySelectorAll('.js--phone-mask')) // инициируем маску для телефона
	},
	updated() {
		this.questionId = window.questionId
		this.questionTitle = window.questionTitle
		phoneMask(document.querySelectorAll('.js--phone-mask')) // инициируем маску для телефона
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	methods: {
		handlerSendForm() {
			this.showValidationError = true

			if (this.isFormValid()) {
				this.isSubmitting = true
				//- вызывает из ./mixins/captcha
				this.initCaptcha()
			}
		},
		submitFormAfterCaptchaCheck(token) {
			const $form = this.$refs.form
			const formData = new FormData($form)
			formData.set('agreement', 1)
			this.axios
				.post($form.action, formData, {
					headers: {
						'Content-type': 'multipart/form-data',
					},
				})
				.then(({ data }) => {
					this.isSubmitting = false
					if (data.success) {
						this.isSend = true
						if (this.isMobile) {
							const element = document.createElement('a')
							element.setAttribute('href', data.data.src)
							element.setAttribute('download', 'file')
							element.style.display = 'none'
							document.body.appendChild(element)
							element.click()
							document.body.removeChild(element)
						} else {
							window.open(data.data.src)
						}
						this.resetForm()
						if (typeof submitCleverData !== 'undefined') {
							submitCleverData('gos-faq-fos-send')
						}
						document.querySelector('.fancybox__backdrop').click()
						return
					}

					this.errorResponse.error = true
					if (data.message) {
						this.errorResponse.text = data.message
						return
					}
					this.errorResponse.text = 'Пожалуйста повторите отправку формы'
				})
				.catch(error => {
					this.errorResponse.error = true
					this.isSubmitting = false
				})
		},
		openConditions() {
			this.showModal()
			this.isShowConditions = true
		},
	},
}
</script>
